import type { RedcatAnalyticsStore } from '../types/store';
import { SignupTrackEventName } from '../types/signup';
import type { SignupTrackEvent } from '../types/events/track';

export const trackSignupTermsAccepted = (
  track: RedcatAnalyticsStore['track'],
  { accepted, isDefaultState }: { accepted: boolean; isDefaultState: boolean },
) => {
  const event: SignupTrackEvent = {
    name: SignupTrackEventName.TermsAccepted,
    properties: {
      accepted,
      is_default_state: isDefaultState,
    },
  };

  track(event);
};
